'use client';

export { default } from './Collapse';
export { default as collapseClasses } from './collapseClasses';
export * from './collapseClasses';